// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__f-96f","header":"MessagesList_header__3pz5h","chat":"MessagesList_chat__HwdjE"};